/* Private ANITIALS pack trial: retain the code across native checkout. */
(() => {
  const codes = JSON.parse(document.currentScript?.dataset.packCodes || '{}');
  const pricing = window.AnitialsPackPricing;
  if (!Object.keys(codes).length || !pricing || window.anitialsPackCheckoutInstalled) return;
  window.anitialsPackCheckoutInstalled = true;
  window.anitialsPackCodesForCart = cart => pricing.codesFor(cart, codes);
  let busy = false;
  const route = window.Shopify?.routes?.root || '/';
  const read = async (url, options) => {
    const response = await fetch(url, options);
    if (!response.ok) throw new Error('No se ha podido verificar el precio del pack. Inténtalo de nuevo.');
    return response.json();
  };
  const checkout = async (event, button) => {
    const container = button.closest('cart-items');
    if (!container?.querySelector('[data-anitials-pack-item]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    const terms = container.querySelector('[data-cart-acceptance-checkbox]');
    if (terms && !terms.checked) { terms.reportValidity(); terms.focus(); return; }
    busy = true;
    button.disabled = true;
    let error = container.querySelector('[data-anitials-pack-checkout-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.anitialsPackCheckoutError = '';
      error.setAttribute('role', 'alert');
      button.parentElement.append(error);
    }
    error.hidden = true;
    try {
      const cart = await read(route + 'cart.js', {cache: 'no-store'});
      const selectedCodes = pricing.codesFor(cart, codes);
      const priced = await read(route + 'cart/update.js', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({discount: selectedCodes.join(',')})
      });
      if (!pricing.verify(priced)) throw new Error('El descuento del pack no coincide. No finalices la compra; revisa el carrito.');
      // Explicitly carry all codes: the theme's blank discount field otherwise clears them.
      window.location.assign(route + 'checkout?discount=' + encodeURIComponent(selectedCodes.join(',')));
    } catch (failure) {
      error.textContent = failure.message;
      error.hidden = false;
    } finally {
      busy = false;
      button.disabled = false;
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('button[name="checkout"]');
    if (button) checkout(event, button);
  }, true);
  document.addEventListener('submit', event => {
    const button = event.submitter;
    if (button?.matches('button[name="checkout"], input[name="checkout"]')) checkout(event, button);
  }, true);
})();

